import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import React from 'react'
import { MainCard } from '../../../components/surface/MainCard'
import { SectionBox } from '../../../components/surface/SectionBox'
import ChartWrapper from '../Charts/ChartWrapper'
import TableComponent from './Table/TableComponent'

type LeadsType = {
  hasScroll?:boolean,
  height?:string,
  minHeight?: string
}

const Leads = ({hasScroll, height, minHeight}:LeadsType) => {
  return (
    <>
      <ChartWrapper title="Recent Leads" hasScroll={hasScroll} height={height} minHeight={minHeight}>
        <Box className="table-container">
          <TableComponent />
        </Box>
      </ChartWrapper >
    </>
  )
}

export default Leads